export function isSmallDevice(minScreenWidth = 576) {
  const screenWidth = window.innerWidth

  return screenWidth <= minScreenWidth
}
